import Header from '../components/general/Header';
import Footer from '../components/general/Footer';
import FaqList from '../components/booking/FaqList';
import s from '../styles/pages/FAQ.module.css';
import site from '../data/master.json';

export default function FAQ() {
  return (
    <div className={s.container}>
      <Header />
      <FaqList data={site.faq} />
      <Footer data={site.footer} />
    </div>
  );
}